import { ca } from '@cian/analytics';

import { EVENT_CATEGORY } from '../../constants/analitics';

export interface ITrackEventProps {
  action: string;
  label: string;
  page?: {
    pageType: string;
    extra: {
      type?: string;
    };
  };
}

export function trackEvent(props: ITrackEventProps): void {
  ca('eventSite', {
    name: 'oldevent',
    category: EVENT_CATEGORY,
    ...props,
  });
}
